'use client';
import { Tooltip } from '@mui/material';
import React from 'react';
import {
  RiCheckboxMultipleBlankLine,
  RiExternalLinkLine,
} from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../Contexts/GlobalContext';

const NAME_POSITION_MAP = {
  left: 'justify-start',
  right: 'justify-end',
  center: 'justify-center',
};

const PersonInfo = ({
  name,
  email,
  tooltipPosition = 'top',
  link,
  namePosition = 'left',
  openLinkInNewTab = false,
  linkWithoutIcon = false,
  showNameTooltip = true,
  showEmailTooltip = true,
  allowCopy = true,
}) => {
  const initials =
    name && name !== '-'
      ? name
          .split(' ')
          .map((n) => n[0])
          .slice(0, 2)
          .join('')
          .toUpperCase()
      : '-';
  const { handleCopy } = useGlobalContext();
  const nameContent = (
    <div className="flex items-center gap-3">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-700">
        {initials}
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-900">{name}</span>
        <span className="text-sm text-gray-600">{email}</span>
      </div>
    </div>
  );
  const handleCopyEmail = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleCopy(email);
  };

  const content = (
    <div className="space-y-1">
      {/* Name row */}
      <div
        className={`flex items-center gap-1 ${NAME_POSITION_MAP[namePosition]}`}
      >
        {showNameTooltip ? (
          <Tooltip title={name} placement="top" className="z-10">
            <h2 className="text-sm font-medium max-w-[175px] truncate">
              {name}
            </h2>
          </Tooltip>
        ) : (
          <h2 className="text-sm font-medium max-w-[175px] truncate">{name}</h2>
        )}

        {link && !linkWithoutIcon && (
          <RiExternalLinkLine size={14} className="text-blue-600 shrink-0" />
        )}
      </div>

      {/* Email row */}
      {!!email && (
        <div className="flex gap-1 items-center text-gray-500">
          {showEmailTooltip ? (
            <Tooltip title={email} placement={tooltipPosition} className="z-10">
              <p className="max-w-[130px] text-xs truncate font-normal">
                {email}
              </p>
            </Tooltip>
          ) : (
            <p className="max-w-[130px] text-xs truncate font-normal">
              {email}
            </p>
          )}

          {!!allowCopy && (
            <RiCheckboxMultipleBlankLine
              size={12}
              className="cursor-pointer shrink-0"
              onClick={handleCopyEmail}
            />
          )}
        </div>
      )}
    </div>
  );

  if (link) {
    return (
      <Link
        to={link}
        target={openLinkInNewTab ? '_blank' : undefined}
        rel={openLinkInNewTab ? 'noopener noreferrer' : undefined}
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default PersonInfo;
